import { render } from "./IconIsDefault.vue?vue&type=template&id=3a9ff1c2"
import script from "./IconIsDefault.vue?vue&type=script&lang=js"
export * from "./IconIsDefault.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__